// db.ts — Dexie (IndexedDB) persistence for CV Web projects
import Dexie, { type EntityTable } from 'dexie';
import type { CVProject } from '../types/panelvar';

export interface SnapshotRow {
  autoId?: number;
  projectId: string;
  createdAt: string;
  data: CVProject;
}

class CVDatabase extends Dexie {
  projects!: EntityTable<CVProject, 'id'>;
  snapshots!: EntityTable<SnapshotRow, 'autoId'>;

  constructor() {
    super('ConstructiVisionDB');
    this.version(1).stores({
      projects: 'id, name, updatedAt',
    });
    this.version(2).stores({
      projects: 'id, name, updatedAt',
      snapshots: '++autoId, projectId, createdAt',
    });
  }
}

export const db = new CVDatabase();
